
if (typeof BSS_B2B !== "undefined" && BSS_B2B) {
    document.addEventListener("click", e => {
        if (e.target && e.target.matches([name="checkout"])) {
            e.preventDefault();
            e.stopPropagation();
            e.stopImmediatePropagation();
            BSS_B2B.observer.cartSubject.notifyObserver('CartCheckout', 'ClickCheckout');
        }
    }, 1);
}
